<template>
<div class="card mb-2">
    <div class="card-header px-2 py-2">
        <span class="label"><b>Tentative {{ getSemesterName(selectedTerm) }} Schedule</b> <v-btn v-if="studentDetailsFromStore.currentStudentUin != ''" icon class="mx-0" @click="download()"><v-icon  title="Print Course Worksheet">print</v-icon></v-btn> <v-btn v-if="studentDetailsFromStore.currentStudentUin != '' && studentDetailsFromStore.isAdvisor == true" icon class="mx-0" @click="openEmailDialog()"><v-icon  title="Email Schedule to Student">email</v-icon></v-btn> <v-btn v-if="studentDetailsFromStore.currentStudentUin != '' && studentDetailsFromStore.isAdvisor == true && typeof studentDetailsFromStore.details.studentRecord !== 'undefined' && typeof studentDetailsFromStore.details.studentRecord.college1 !== 'undefined' && studentDetailsFromStore.details.studentRecord.college1.code == 'PD'" icon class="mx-0" @click="openEmailDialogCHSTSurvey()"><v-icon  title="Email link to the CHST Advising Survey">mdi-account-star</v-icon></v-btn></span>
    </div>
    <div class="card-body p-0 px-1">
        <div class="table-responsive-md" v-if="Object.keys(tentativeCourses).length > 0">
        <table class="table">
            <thead class="thead-dark">
            <tr>
                <th></th>
                <th>M</th>
                <th>T</th>
                <th>W</th>
                <th>TH</th>
                <th>F</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="start in Object.keys(tentativeCourses).sort()">
                <template v-if="start !== 'online'">
                  <tr>
                    <td>{{ convertToReadableTime(start) }}</td>
                    <td v-for="(courses, day) in tentativeCourses[start]">
                      <template v-for="course in courses">
                        <tr :style="`${ (course.is_conflict == true) ? 'color: red':'black'}`">{{ course.course_name }}</tr>
                      </template>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td>{{ start }}</td>
                    <td>
                      <template v-for="course in tentativeCourses[start]">
                        {{ course.course_name }}
                      </template>
                    </td>
                  </tr>
                </template>
            </template>
            </tbody>
        </table>
        </div>
        <p v-else>No schedule found for the {{ getSemesterName(selectedTerm) }} term.</p>
    </div>
<v-dialog v-model="dialogEmail" scrollable width="600">
      <v-card class="" v-if="typeof studentDetailsFromStore.details.firstname !== 'undefined'">
        <v-card-title class="font-semibold"
          ><span>Email  {{ studentDetailsFromStore.details.firstname.split(" ")[0]  + ' ' + this.studentDetailsFromStore.details.lastname.split(" ")[0] }} the {{ selectedTerm }} schedule?</span>
          <v-spacer></v-spacer>
          <v-icon @click="closeEmailDialog">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-spacer></v-spacer>
<v-checkbox
      v-model="change_of_major"
      label="Add Change of Major Info To the Email"
      :value=true></v-checkbox>
          <v-spacer></v-spacer>
                      <v-textarea
		v-model="additional_text" rows="4"
          label="Additional Text For the Email" ></v-textarea>
              <v-btn color="primary" @click="email_schedule">Yes - Send</v-btn>
              <v-btn append-icon="search" color="success" onclick="return popup(this.href, 800, 1024);" :href="`tentativecourses/previewemailschedule?term_cd=${selectedTerm}&uin=${uin}&change_of_major=${change_of_major}&additional_text=${additional_text}`" target="_blank">Preview</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
	<v-dialog v-model="dialogEmailCHSTSurvey" scrollable width="600">
      <v-card class="" v-if="typeof studentDetailsFromStore.details.firstname !== 'undefined'">
        <v-card-title class="font-semibold"
          ><span>Email  {{ studentDetailsFromStore.details.firstname.split(" ")[0]  + ' ' + this.studentDetailsFromStore.details.lastname.split(" ")[0] }} the link to the CHST Advising Survey?</span>
          <v-spacer></v-spacer>
          <v-icon @click="closeEmailDialogCHSTSurvey">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-spacer></v-spacer>
              <v-btn color="primary" @click="email_chst_survey">Yes - Send</v-btn>
        </v-card-text>
      </v-card>
	</v-dialog>
    <div class="card-footer px-2 py-2">
        <span class="label"><b>Registered Courses:</b> {{ registered_courses }} <span v-if="(registered_courses !== '') && (result_diff_a !== '' || result_diff_b !== '')">(<span v-if="result_diff_a !== ''">Missing: {{ result_diff_a }}</span><span v-if="result_diff_b !== ''">|Extra: {{ result_diff_b }}</span>)</span><span v-else><i v-if="registered_courses !== ''" class="material-icons" style="color:teal" title="Tentative courses match registered courses">check</i></span></span>
        <br>
        <span class="label"><b>Total Registered Hours:</b> {{ total_registered_hours }}</span>
    </div>
</div>
</template>

<script>
 import {format } from "date-fns"; 
 import { parseISO } from "date-fns/fp";
import { mapState } from 'vuex'

export default {
  data() {
    return {
      appname: process.env.MIX_APP_NAME,
      dialogEmail: false,
      dialogEmailCHSTSurvey: false,
      change_of_major: false,
      registered_courses: '',
      total_registered_hours: 0,
      result_diff_a: '',
      result_diff_b: '',
      additional_text: ''
    };
  },
  computed: {
    ...mapState({
        currentStudentUinFromStore: state => state.student.currentStudentUin,
        selectedTermFromStore: state => state.term.selected,
        currentScheduleFromStore: state => state.currentschedule.courses,
        newTentativeCoursesFromStore: state => state.courses.tentativeCourses,
        studentDetailsFromStore: state => state.student,
    }),
    uin: {
        get(){
          return this.currentStudentUinFromStore
        },
        set(newName){
          return newName
        } 
    },
    selectedTerm: {
        get(){
          return this.selectedTermFromStore
        },
        set(newName){
          return newName
        } 
    },
    tentativeCourses: {
        get(){
          return this.currentScheduleFromStore
        },
        set(newName){
          return newName
        } 
    },
    newTentativeCourses: {
      get(){
          return this.newTentativeCoursesFromStore
      },
      set(newName){
        return newName
      } 
    }
  },
  created() {
  },
  watch: {
      uin: function (val) {
        if (this.selectedTerm !== '') {
          this.getCurrentTermSchedule();
	  this.getCurrentTermRegisteredCourses();
        }
      },
      selectedTerm: function (val) {
        if (this.uin !== '') {
          this.getCurrentTermSchedule();
	  this.getCurrentTermRegisteredCourses();
        }
      },
      newTentativeCourses: function (val) {
        if (this.uin !== '' || this.selectedTerm !== '') {
          this.getCurrentTermSchedule();
	  this.getCurrentTermRegisteredCourses();
        }
      },
  },
  mounted() {
    
  },
  methods: {
    openEmailDialog() {
      this.dialogEmail = true;
    },
    closeEmailDialog() {
      this.dialogEmail = false;
    },
    openEmailDialogCHSTSurvey() {
      this.dialogEmailCHSTSurvey = true;
    },
    closeEmailDialogCHSTSurvey() {
      this.dialogEmailCHSTSurvey = false;
    },
    sortCurrentCoursesBgnDesc(courses) {
      return courses.slice().sort(function(a,b){return (a.sect_bgn_tim < b.sect_bgn_time) ? -1 : 1});
    },
    convertToReadableTime(timeStr) {
      if (timeStr == ' ') {
        return 'Online';
      } else if (timeStr == 'Mult') {
        return 'MULT';
      }
      return format(new Date (parseISO(`2020-10-10 ${timeStr.substring(0, 2)}:${timeStr.substring(2, 4)}:00`)), "hh:mm a")
     // return `${timeStr.substring(0, 2)}:${timeStr.substring(2, 4)}`
    },
    groupBy(OurArray, property) {  
      return OurArray.reduce(function (accumulator, object) { 
        const key = object[property]; 
        if (!accumulator[key]) {      
          accumulator[key] = [];    
        }    
        accumulator[key].push(object);
      return accumulator;  
      }, {});
    },
    generateScheduleTableArr(data) {
     
      let reformatData = [];
      data.forEach(course => {
        if (course.sect_mtg_time_days == '') {
          reformatData.push({
              sect_bgn_time: '',
              sect_end_time: '',
              day: '',
              course_instructor: course.course_instructor,
              course_name: course.course_name,
              course_schedule_type: course.course_schedule_type,
              crn: course.crn
          });
        } else {
        let multiTimeDays = (course.sect_mtg_time_days).split("|");
        multiTimeDays.forEach(element => {
          let timeDays = element.split(':');
          let timeArr = (timeDays[0]).split('-');
          let daysArr = (timeDays[1]).split(',');
          
          daysArr.forEach(day => {
            reformatData.push({
              sect_bgn_time: timeArr[0],
              sect_end_time: timeArr[1],
              day: day,
              course_instructor: course.course_instructor,
              course_name: course.course_name,
              course_schedule_type: course.course_schedule_type,
              crn: course.crn
            });
          });
        });
        }
      });
      let tableData = this.groupBy(reformatData, 'sect_bgn_time');
      let newData = new Object();
      let prevKey = '';
      Object.keys(tableData).sort().forEach((startTime, index) => {
        if (startTime == "") {
          newData["online"] = tableData[startTime];
        } else {
          newData[startTime] = new Object();
          newData[startTime]['M'] = this.filterCoursesByStartTimeDay(tableData, prevKey, startTime, 'M')
          newData[startTime]['T'] = this.filterCoursesByStartTimeDay(tableData, prevKey, startTime, 'T')
          newData[startTime]['W'] = this.filterCoursesByStartTimeDay(tableData, prevKey, startTime, 'W')
          newData[startTime]['R'] = this.filterCoursesByStartTimeDay(tableData, prevKey, startTime, 'R')
          newData[startTime]['F'] = this.filterCoursesByStartTimeDay(tableData, prevKey, startTime, 'F')
        }
        prevKey = startTime;
      });
      return newData;
    },
    filterCoursesByStartTimeDay(data, prevStart, start, day) {
      var filtered = data[start].filter(element => element.day == day);
      if (filtered.length > 0) {
        if (prevStart != '') {
          var result = data[prevStart].filter(element => element.day == day)
          var prevEnd = (result.length > 0) ? result[0]['sect_end_time'] : '';
          filtered.forEach(element => {
            if (element.sect_bgn_time > prevStart && element.sect_bgn_time < prevEnd ) {
              element['is_conflict'] = true;
            } else {
              element['is_conflict'] = false;
            }
          });
        } else {
          filtered.forEach((element, index) => {
            if (element.sect_bgn_time == start && index != 0) {
              element['is_conflict'] = true;
            } else {
              element['is_conflict'] = false;
            }
          });
        }
      }
      return filtered;
    },
    async getCurrentTermSchedule() {
      let uin = this.uin;
      this.$store.commit("status/setStatus", {snack: true, snackColor: 'info', snackText: 'Please wait while we fetch current semester schedule...'});
      await axios.get('/api/v1/studentcurrentschedule/'+uin+'/'+this.selectedTerm)
        .then((response) => {
          if (response.data.length == 0) {
            this.$store.commit("currentschedule/setCourses",  this.generateScheduleTableArr(response.data));
            this.$store.commit("status/setStatus", {snack: true, snackColor: 'error', snackText: 'No record found for the current semester'});
            return;
          }
          // this.generateScheduleTableArr(response.data)
          this.$store.commit("currentschedule/setCourses",  this.generateScheduleTableArr(response.data));
        })
      .catch(error => {});
    },
 async getCurrentTermRegisteredCourses() {
      let uin = this.uin;
      await axios.get('/api/v1/cdmattendancestucourseslive/'+uin+'/'+this.selectedTerm)
        .then((response) => {
		this.registered_courses = response.data.registered_courses;
		this.result_diff_a = response.data.result_diff_a;
		this.result_diff_b = response.data.result_diff_b;
        this.total_registered_hours = response.data.total_registered_hours;
          }
        )
      .catch(error => {});
    },
  async email_schedule(){
           //if(confirm('Are you sure you want to email ' +  this.studentDetailsFromStore.details.firstname.split(" ")[0]  + ' ' + this.studentDetailsFromStore.details.lastname.split(" ")[0] + ' the ' + this.selectedTerm + ' schedule?'))
            //{
                await axios.post('/api/v1/tentativecourses' + '/emailschedule', {
 		term_cd: this.selectedTerm,
        uin: this.uin,
		change_of_major: this.change_of_major,
		additional_text: this.additional_text
            }).then((response) => {
                     if(response.data.message == "Success"){
            	     this.$store.commit("status/setStatus", {snack: true, snackColor: 'success', snackText: 'Schedule emailed successfully.'});
                   
                     }
                     else{
            	     this.$store.commit("status/setStatus", {snack: true, snackColor: 'error', snackText: 'Something went wrong, the schedule could not be emailed.'});
                     }
                }).catch(error => {
            	        this.$store.commit("status/setStatus", {snack: true, snackColor: 'error', snackText: 'An error occurred , the schedule could not be emailed.'});
            		})
	    //}
            //else
            //{
            //   
            //}
	    this.change_of_major = false;
	    this.additional_text = '';
	    this.dialogEmail = false;
    },
    async email_chst_survey(){
        await axios.post('/api/v1/tentativecourses' + '/emailchstsurvey', {
        uin: this.uin,
            }).then((response) => {
                     if(response.data.message == "Success"){
            	     this.$store.commit("status/setStatus", {snack: true, snackColor: 'success', snackText: 'CHST Advising Survey link emailed successfully.'});
                   
                     }
                     else{
            	     this.$store.commit("status/setStatus", {snack: true, snackColor: 'error', snackText: 'Something went wrong, the survey could not be emailed.'});
                     }
                }).catch(error => {
            	        this.$store.commit("status/setStatus", {snack: true, snackColor: 'error', snackText: 'An error occurred , the survey could not be emailed.'});
            		})
	    this.dialogEmailCHSTSurvey = false;
    },
    download(){
     
       axios({
          url: '/tentativecourses/' + this.uin + '/' + this.selectedTerm + '/advisepdf',
          method: 'POST',
          data: { scheduleGridData: this.tentativeCourses },
          responseType: 'blob', // important
        }).then((response) => {
          if (!window.navigator.msSaveOrOpenBlob){
            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/pdf'}));
            const link = document.createElement('a');
            link.href = url;
            //const date = new Date();
            const sem_year = this.selectedTerm.substring(1, 5);
            var semester = '';
            if(this.selectedTerm.split('')[5] == 1)
            {
            semester  = 'Spring' + sem_year;	
            }
            else if(this.selectedTerm.split('')[5] == 5)
            {
            semester = 'Summer' + sem_year;
            }
            else
            {
            semester = 'Fall' + sem_year;
            }

            link.setAttribute('download', this.studentDetailsFromStore.details.firstname.split(" ")[0]  + '_' + this.studentDetailsFromStore.details.lastname.split(" ")[0]  + '_' + semester  + '.pdf');
            document.body.appendChild(link);
            link.click();
          }else{
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), this.appname + '_app_export_' + date.getTime() + '.pdf');
          }
        }).catch(error=>{
           
        })	
    },
	getSemesterName(term_cd)
		{
		var semester_name = '';
		var sem_year = term_cd.substring(1, 5);
		var semester_initial = term_cd.substring(5);

		if(semester_initial == '5')
		{
			semester_name = 'Summer ' + sem_year;
		}
		else if(semester_initial == 1)
		{
			semester_name = 'Spring ' + sem_year;
		}
		else
		{
			semester_name = 'Fall ' + sem_year;
		}

		return semester_name;
		},
  }
};
</script>
